<template>
  <v-navigation-drawer
    v-model="Sidebar_drawer"
    :dark="SidebarColor !== 'white'"
    :color="SidebarColor"
    mobile-break-point="960"
    clipped
    :right="$vuetify.rtl"
    mini-variant-width="70"
    :expand-on-hover="expandOnHover"
    app
    id="main-sidebar"
    :width="230"
  >
    <v-list dense nav>
      <!---USer Area -->
      <!-- <v-list-item two-line class="px-0">
        <v-list-item-avatar>
          <img src="https://randomuser.me/api/portraits/men/81.jpg" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Dohn Deo</v-list-item-title>
          <v-list-item-subtitle class="caption">Webdesigner</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item> -->
      <!---USer Area -->
      <!---Sidebar Items -->
      <v-list-item
        v-for="item in adminitems"
        :key="item.title"
        :to="item.to"
        :active-class="`red white--text`"
        link
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!---Sidebar Items -->
      <v-list-group :value="false" no-action prepend-icon="mdi-file-image">
        <template v-slot:activator>
          <v-list-item-title>Add Images</v-list-item-title>
        </template>
        <v-list-item
          v-for="item in images"
          :key="item.title"
          :to="item.to"
          :active-class="`red white--text`"
          link
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Sidebar",
  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    userRole: localStorage.getItem("role"),
    adminitems: [
      {
        title: "Dashboard",
        icon: "mdi-view-dashboard",
        to: "/dashboard",
      },
      {
        title: "Customers",
        icon: "mdi-account -circle",
        to: "/Users",
      },

      // {
      //   title: "Bussiness Verification",
      //   icon: "mdi-account-multiple",
      //   to: "/customers"
      // },

      // {
      //   title: "Bussiness & Orders",
      //   icon: "mdi-book-open",
      //   to: "/Orders"
      // },
      // {
      //   title: "GST",
      //   icon: "mdi-cash-multiple",
      //   to: "/gst",
      // },

      {
        title: "Sellers",
        icon: "mdi-account-multiple",
        to: "/Sellers",
      },
      {
        title: "Seller Verification",
        icon: "mdi-account-multiple-plus",
        to: "/sellerVerification",
      },
      {
        title: "Seller Sold",
        icon: "mdi-account-check",
        to: "/sellerSold",
      },
      {
        title: "Offers",
        icon: "mdi-offer",
        to: "/offers",
      },
      {
        title: "Offer Verification",
        icon: "mdi-offer",
        to: "/offerVerification",
      },
      {
        title: "Category",
        icon: "mdi-view-list",
        to: "/category",
      },
      {
        title: "Discount Products",
        icon: "mdi-brightness-percent",
        to: "/discountProducts",
      },
      {
        title: "Pending Discount",
        icon: "mdi-percent",
        to: "/discountVerification",
      },
      {
        title: "Products",
        icon: "mdi-package-variant-closed",
        to: "/Products",
      },
      {
        title: "Product Verification",
        icon: "mdi-package-variant",
        to: "/productVerification",
      },
      {
        title: "Cancelled Products",
        icon: "mdi-cancel",
        to: "/cancelledProducts",
      },
      {
        title: "Returned Products",
        icon: "mdi-keyboard-return",
        to: "/returnedProducts",
      },

      {
        title: "Orders",
        icon: "mdi-newspaper",
        to: "/Purchases",
      },
      {
        title: "Purchase",
        icon: "mdi-cart",
        to: "/purchaseList",
      },
    ],
    images: [{ title: "Category-Slider", to: "/addImage/category" }],
  }),
  computed: {
    ...mapState(["SidebarColor", "SidebarBg"]),
    Sidebar_drawer: {
      get() {
        return this.$store.state.Sidebar_drawer;
      },
      set(val) {
        this.$store.commit("SET_SIDEBAR_DRAWER", val);
      },
    },
  },
  watch: {
    "$vuetify.breakpoint.smAndDown"(val) {
      this.$emit("update:expandOnHover", !val);
    },
  },

  methods: {},
};
</script>
<style lang="scss">
#main-sidebar {
  box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
  -webkit-box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
  .v-navigation-drawer__border {
    display: none;
  }
  .v-list {
    padding: 8px 15px;
  }
  .v-list-item {
    &__icon--text,
    &__icon:first-child {
      justify-content: center;
      text-align: center;
      width: 20px;
    }
  }
  .success {
    background-color: #1e88e5 !important;
    border-color: #1e88e5 !important;
  }
}
</style>